import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'
import { AccEntrySearchParams } from '@lk/api'

export const accEntrySearch = createAsyncThunk<any, AccEntrySearchParams, ThunkApi>(
  '[ACC_ENTRY] SEARCH',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.search(params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntrySearchMain = createAsyncThunk<any, AccEntrySearchParams & { searchAgain?: boolean }, ThunkApi>(
  '[ACC_ENTRY] SEARCH_MAIN',
  async (params, { extra, rejectWithValue, getState }) => {
    let searchparams = params
    if (params.searchAgain) {
      delete params.searchAgain
      searchparams = getState().accEntryData.searchParams
    }

    const result = await extra.api.accEntry.search(searchparams)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const destroyAccEntrySearch = createAction('[ACC_ENTRY] DESTROY_SEARCH_MAIN')
